import axiosInstance from "../../api";

import { Dispatch } from "redux";

import { alertActions } from "./alert.actions";
import {
  LOADING_WORKTYPE,
  LOADING_WORKTYPE_SUCCESS,
  LOAD_WORKTYPE,
  WORKTYPE_SAVE_SUCCESS,
} from "../types/worktype.types";

export const loadWorktypes = (filterData: any) => (dispatch: Dispatch) => {
  dispatch({ type: LOADING_WORKTYPE });
  axiosInstance
    .get(`worktype/`, { params: filterData })
    .then((response) => {
      dispatch({ type: LOAD_WORKTYPE, payload: response?.data });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch(alertActions.error("Network error"));
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
      }
    })
    .finally(() => {
      dispatch({ type: LOADING_WORKTYPE_SUCCESS });
    });
};

export const addWorktype = (worktype: string) => (dispatch: Dispatch) => {
  dispatch({ type: LOADING_WORKTYPE });
  axiosInstance
    .post(`schedule/worktype`, { work_type: worktype })
    .then((res: any) => {
      dispatch({ type: WORKTYPE_SAVE_SUCCESS });
      dispatch(alertActions.success("Worktype added successfully"));
    })
    .catch((err: any) => {
      if (err.response.status === 0) {
        dispatch(alertActions.error("Network error"));
      } else if (err?.response?.message) {
        dispatch(alertActions.error(err.response.message));
      } else {
        dispatch(alertActions.error("Add worktype failed"));
      }
    });
};
export const editWorktype =
  (worktype: string, id: string) => (dispatch: Dispatch) => {
    dispatch({ type: LOADING_WORKTYPE });
    axiosInstance
      .put(`worktype/${id}`, { work_type: worktype })
      .then((res: any) => {
        dispatch({ type: WORKTYPE_SAVE_SUCCESS });
        dispatch(alertActions.success("Worktype edited successfully"));
      })
      .catch((err: any) => {
        if (err.response.status === 0) {
          dispatch(alertActions.error("Network error"));
        } else if (err?.response?.message) {
          dispatch(alertActions.error(err.response.message));
        } else {
          dispatch(alertActions.error("Edit worktype failed"));
        }
      });
  };
export const deleteWorktype = (id: string) => (dispatch: Dispatch) => {
  dispatch({ type: LOADING_WORKTYPE });

  axiosInstance
    .delete(`worktype/${id}`)
    .then((res: any) => {
      dispatch({ type: WORKTYPE_SAVE_SUCCESS });
      dispatch(alertActions.success("Worktype deleted successfully"));
    })
    .catch((err: any) => {
      dispatch(alertActions.showError(err, "Delete worktype failed"));
      dispatch({ type: LOADING_WORKTYPE_SUCCESS });
    });
};

export const bulkWorktypeDelete =
  (formData: any, filterData: any) => (dispatch: Dispatch) => {
    dispatch({ type: LOADING_WORKTYPE });
    axiosInstance
      .delete("worktype", { data: formData })
      .then((res) => {
        dispatch(alertActions.success("Worktype deleted successfully"));

        dispatch<any>(loadWorktypes({ page: 1, size: 10 }));
      })
      .catch((err) => {
        dispatch(alertActions.showError(err, "Delete worktype failed"));

        dispatch({ type: LOADING_WORKTYPE_SUCCESS });
      });
  };
